import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function HomePage() {
  const { user } = useAuth()
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error') || ''

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl sm:text-5xl font-bold tracking-tight text-slate-900">
          Brooklinen Services
        </h1>
      </div>

      {user ? (
        <>
          <div className="card p-5 sm:p-6 mb-6">
            <p className="text-sm text-slate-600">Signed in as:</p>
            <p className="font-medium">
              {user.email}{' '}
              <span className="ml-2 text-xs px-2 py-0.5 rounded bg-slate-100 text-slate-600 align-middle">
                {user.role}
              </span>
            </p>
          </div>

          <h2 className="text-lg font-semibold text-slate-900 mb-3">Services</h2>
          <div className="grid gap-4 sm:grid-cols-2">
            <Link
              to="/trade_applications"
              className="card p-5 hover:border-brand-500 hover:shadow-md transition block"
            >
              <div className="font-medium text-slate-900">Trade &amp; Hospitality Applications</div>
              <div className="text-sm text-slate-600 mt-1">
                Review Trade and Hospitality applications.
              </div>
            </Link>
          </div>
        </>
      ) : (
        <div className="card p-6 sm:p-8 text-center max-w-md mx-auto">
          <p className="text-slate-700 mb-5">Sign in to access internal services.</p>
          {error && (
            <div className="mb-4 p-3 rounded-md bg-rose-50 border border-rose-200 text-sm text-rose-800 text-left">
              {error}
            </div>
          )}
          <Link to="/login" className="btn-primary w-full">Sign in</Link>
        </div>
      )}
    </div>
  )
}
